<template>
  <nav ref="navbar" class="navbar fixed-top" @click="handleClickOutside">
    <div class="brand-container">
  <span class="brand-bold">MY EVENTO</span>
  <span class="brand-script">Digital</span>
</div>

    <button class="navbar-toggler" type="button" @click="toggleMenu">
      <span class="navbar-toggler-icon" />
    </button>

    <ul :class="{ 'nav-pills': true, 'show': isMenuVisible }" @click.stop>
      <li class="nav-item" @click="goTosubirlista">
        <button class="btn nav-button">Subir Lista</button>
      </li>
      <li class="nav-item" @click="goToAgregarInvitado">
        <button class="btn nav-button">Agregar Invitados</button>
      </li>
      <li class="nav-item" @click="goToConfirmados">
        <button class="btn nav-button">Invitados Confirmados</button>
      </li>
      <li class="nav-item" @click="goToAlbum">
        <button class="btn nav-button">Álbum Fotos</button>
      </li>
      <li class="nav-item" @click="goToScanPass">
        <button class="btn nav-button-warning">Lector Pases</button>
      </li>
      <li class="nav-item" @click="goToDashboard">
  <button class="btn nav-button">Dashboard</button>
</li>

      <li class="nav-item" @click="goToOrganizador">
  <button class="btn nav-button">Organizador de Mesas</button>
</li>
      <li class="nav-item profile-container" @click.stop="toggleProfileMenu">
        <span class="profile-label">Mi perfil</span>
        <ul v-if="isProfileMenuVisible" class="profile-dropdown">
          <li @click="goToProfile">Mi Perfil</li>
          <li @click="confirmarCerrarSesion">Cerrar Sesión</li>
        </ul>
      </li>
    </ul>
  </nav>
</template>

<script>
import Swal from "sweetalert2";
import { useRouter } from "vue-router";
import { ref, onMounted, onUnmounted } from "vue";
import gsap from "gsap";


export default {
  setup() {
    let lastScrollTop = 0;

    const router = useRouter();
    const isMenuVisible = ref(false);
    const isProfileMenuVisible = ref(false);
    const navbar = ref(null);


  

    const goToOrganizador = () => {
  closeMenu();
  router.push({ name: "organizador" });
};



    const handleClickOutside = (event) => {
      if (navbar.value && !navbar.value.contains(event.target)) {
        isMenuVisible.value = false;
        isProfileMenuVisible.value = false;
      }
    };

      // 👇 Animación con GSAP
  const animarNavbar = (mostrar) => {
    gsap.to(navbar.value, {
      y: mostrar ? 0 : -100,
      duration: 0.4,
      ease: "power2.out"
    });
  };

    const toggleMenu = () => {
      isMenuVisible.value = !isMenuVisible.value;
    };

    const toggleProfileMenu = () => {
      isProfileMenuVisible.value = !isProfileMenuVisible.value;
    };

    const closeMenu = () => {
      isMenuVisible.value = false;
    };

    const goTosubirlista = () => {
      closeMenu();
      router.push({ name: "subirlista" });
    };

    const goToAgregarInvitado = () => {
      closeMenu();
      router.push({ name: "AgregarInvitado" });
    };

    const goToConfirmados = () => {
      closeMenu();
      router.push({ name: "confirmados" });
    };

    const goToAlbum = () => {
      closeMenu();
      router.push({ name: "albumfotos" });
    };

    const goToProfile = () => {
      closeMenu();
      isProfileMenuVisible.value = false;
      router.push({ name: "miperfil" });
    };

    const goToScanPass = () => {
      closeMenu();
      router.push({ name: "lectorcodigo" });
    };

const goToDashboard = () => {
  closeMenu();
  router.push({ name: "dashboard" });
};
    
    const confirmarCerrarSesion = () => {
      Swal.fire({
        title: "¿Estás seguro?",
        text: "Tu sesión se cerrará y tendrás que iniciar sesión nuevamente.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#9c949c",
        cancelButtonColor: "#827a82",
        confirmButtonText: "Sí, cerrar sesión",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.isConfirmed) {
          localStorage.removeItem("id_festejada");
          router.push({ name: "Login" });
        }
      });
    };

    onMounted(() => {
      document.addEventListener("click", handleClickOutside);
      document.addEventListener("scroll", () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop < 50) {
        animarNavbar(true);
      } else if (scrollTop > lastScrollTop) {
        animarNavbar(false);
      } else {
        animarNavbar(true);
      }

      lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
    });

    document.addEventListener("click", handleClickOutside);
  
    });

    onUnmounted(() => {
      document.removeEventListener("click", handleClickOutside);
      
    });

    return {
      confirmarCerrarSesion,
      goTosubirlista,
      goToAgregarInvitado,
      goToConfirmados,
      goToAlbum,
      goToProfile,
      goToScanPass,
      goToDashboard,

      isMenuVisible,
      isProfileMenuVisible,
      toggleMenu,
        goToOrganizador,

      toggleProfileMenu,
      navbar,
    };
  },
};
</script>

<style scoped>
.navbar {
  background: linear-gradient(to right, #fdfcfa, #f8f6f4);
  padding: 16px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.05);
  border-radius: 0 0 20px 20px;
}

.logo {
  height: 90px;
  width: auto;
}

.nav-pills {
  display: flex;
  gap: 28px;
  list-style: none;
  margin: 0;
  padding: 0;
  align-items: center;
  font-family: 'Playfair Display', serif;
  font-weight: 500;
  font-size: 14px;
  color: #4c4f54;
}

.nav-item .btn {
  background: none;
  border: none;
  color: #4c4f54;
  font-family: 'Playfair Display', serif;
  font-size: 14px;
  font-weight: 500;
  padding: 0;
  border-radius: 0;
  box-shadow: none;
  transition: all 0.3s ease;
}

.nav-item .btn:hover {
  text-decoration: underline;
  transform: translateY(-1px);
}

.nav-button-warning {
  color: #8c7e6e;
}

.profile-container {
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 14px;
  color: #5a4b51;
  font-family: 'Playfair Display', serif;
}

.profile-label {
  font-size: 30px;

  font-family: 'serenety', serif;
  font-weight:500;
}

.profile-icon {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid white;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);
}

.profile-dropdown {
  position: absolute;
  top: 48px;
  right: 0;
  background: white;
  border-radius: 12px;
  padding: 10px 0;
  width: 160px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.06);
  z-index: 10;
}

.profile-dropdown li {
  padding: 10px 18px;
  cursor: pointer;
  transition: background 0.3s ease;
}

.profile-dropdown li:hover {
  background-color: #f8f6f4;
}

.navbar-toggler {
  display: none;
  background: transparent;
  border: none;
}

.navbar-toggler-icon {
  width: 28px;
  height: 3px;
  background-color: #7a8899;
  position: relative;
  border-radius: 4px;
}

.navbar-toggler-icon::before,
.navbar-toggler-icon::after {
  content: "";
  position: absolute;
  width: 28px;
  height: 3px;
  background-color: #7a8899;
  transition: all 0.3s ease-in-out;
}

.navbar-toggler-icon::before {
  top: -8px;
}

.navbar-toggler-icon::after {
  top: 8px;
}

@media (max-width: 768px) {
  .navbar-toggler {
    display: block;
  }

  .nav-pills {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: #fdfcfa;
    flex-direction: column;
    padding: 20px;
    border-radius: 0 0 20px 20px;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.06);
    display: none;
    transition: all 0.4s ease-in-out;
    align-items: center;
  }

  .nav-pills.show {
    display: flex;
  }

  .nav-item .btn {
    width: auto;
    max-width: 240px;
    min-width: 180px;
    margin: 6px auto;
    text-align: center;
  }
}
.brand-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  line-height: 1;
  margin-left: 12px;
}

.brand-bold {
  font-family: 'Playfair Display', serif;
  font-size: 19px;
  font-weight: 400;
  letter-spacing: 0.5px;
  color: #3f3f3f; /* más suave */
  text-transform: capitalize;
}

.brand-script {
  font-family: 'serenety', cursive;
  font-size: 30px;
  color: #8c7e6e;
  font-weight: 400;
  margin-left: 2px;
  margin-top: 2px;
  text-align: center;
  width: 100%;
}

</style>
